module.exports = __webpack_public_path__ + "img/imunizacao.2bbb26b9.png";